var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-check app-checkbox",class:{
    'is-active': _vm.value,
    disabled: _vm.disabled == true,
    'size-default': _vm.size === 'default',
    'size-small': _vm.size === 'small'
  },on:{"click":_vm.changeValue}},[_c('div',{staticClass:"empty-space"}),_c('label',[_c('div',{ref:"box",staticClass:"box",class:{ checked: _vm.value }},[_c('svg',{attrs:{"viewBox":"0 0 50 50"}},[_c('path',{attrs:{"d":"M5 30 L 20 45 L 45 10"}})])]),_c('span',[_vm._v(" "+_vm._s(_vm.label)+" ")])]),(_vm.infoTip)?_c('info-tip',{attrs:{"title":_vm.infoTip,"position":'right'}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }